import eventBus from 'toxilibs/event_bus_queued.js'
import $ from 'jquery'
import toxicodeRemoteChallenge from 'toxilibs/toxicode_remote_challenge.js'

let remoteMode = toxicodeRemoteChallenge.checkRemoteMode()

if (remoteMode) {
    if (remoteMode.error) {
        $('body').html('Remote Challenge Error : ' + remoteMode.error)
    } else {
        enableRemoteChallenge(remoteMode)
    }
}


function enableRemoteChallenge () {
    eventBus.on('game ended', displayEnd)
}


function displayEnd () {
    setTimeout(function () {
        remoteMode.goBack('won')
    }, 4000)
}

